import React from 'react'

export default function Hero() {
    return (
        <div className="row">
            <div className="col s12">
            <h1>APIY</h1>
            <blockquote>
                a lightweight plugin that makes asynchronous <b>Api</b> calls, one second of code!
            </blockquote>
            <p>Try it now!</p>
            </div>
        </div>
    )
}
